module.exports = __webpack_public_path__ + "fj.6503b5caef3c1a3266af.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/fj.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/fj.svg
// module chunks = styles